import { render } from "./WorkFormDeceasedCoffinPuttingInfo.vue?vue&type=template&id=59463b2e"
import script from "./WorkFormDeceasedCoffinPuttingInfo.vue?vue&type=script&lang=js"
export * from "./WorkFormDeceasedCoffinPuttingInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__